// extracted by mini-css-extract-plugin
export var container = "RotatingMessageList-module--container--3dEc2";
export var overflowWrap = "RotatingMessageList-module--overflowWrap--3bxxb";
export var messageItem = "RotatingMessageList-module--messageItem--3K1CK";
export var active = "RotatingMessageList-module--active--LCAZ6";
export var visible = "RotatingMessageList-module--visible--3ZY1_";
export var upperShadow = "RotatingMessageList-module--upperShadow--ni4qs";
export var bottomShadow = "RotatingMessageList-module--bottomShadow--331vk";